import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from 'react-select';
import { postMrpTypeDatas } from "../../../redux/action";
import { useDispatch } from "react-redux";
import { ADDED_BY_ID } from "../../../Constants";
import * as HeaderAuthentication from '../../HeaderAuthentication'

const enablingOptions = [
    { value: 81, label: "Active" },
    { value: 82, label: "Inactive" }
]

const AddMrpType = (props) => {

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedCompanyID = signInDetails ? signInDetails[0].CompanyID : null;
    let dispatch = useDispatch();

    const [mrpTypeData, setMrpTypeData] = useState({
        MRPTypeCode: "",
        MRPTypeDescription: "",
        CompanyID: storedCompanyID,
        AddedByID: ADDED_BY_ID,
        StatusID: null
    });

    const [errors, setErrors] = useState({
        MRPTypeCode: "",
        MRPTypeDescription: ""
    });

    useEffect(() => {
        if (props.mrpTypeID && props.singleMrpTypeData?.length > 0) {
            const mrpTypeData = props.singleMrpTypeData[0];
            setMrpTypeData({
                MRPTypeID: props.mrpTypeID,
                MRPTypeCode: mrpTypeData.MRPTypeCode || "",
                MRPTypeDescription: mrpTypeData.MRPTypeDescription || "",
                CompanyID: mrpTypeData.CompanyID,
                AddedByID: ADDED_BY_ID,
                StatusID: mrpTypeData.StatusID || null
            });
        }
    }, [props.mrpTypeID, props.singleMrpTypeData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setMrpTypeData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "" // Clear error on typing
        }));
    };

    const handleStatusChange = (selectedOption) => {
        setMrpTypeData((prevData) => ({
            ...prevData,
            StatusID: selectedOption ? selectedOption.value : null
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!mrpTypeData.MRPTypeCode.trim()) {
            newErrors.MRPTypeCode = "MRP Type Code is required!";
        }
        if (!mrpTypeData.MRPTypeDescription.trim()) {
            newErrors.MRPTypeDescription = "MRP Type Description is required!";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const AddMrpTypeData = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify(mrpTypeData),
            };
            dispatch(postMrpTypeDatas(requestOption, props.handleCloseModal, props.mrpTypeID, props.mrpTypeDatas));
            console.log(mrpTypeData, 'mrpTypeData');
        }
    };

    return (
        <>
            <Modal show={props.open} onHide={props.handleCloseModal} className='add-role-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>{props.mrpTypeID ? "Edit MRP Type" : "Add MRP Type"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={12}>
                                    <div>
                                        <label className="pb-2 pt-2">MRP Type Code <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            name="MRPTypeCode"
                                            value={mrpTypeData.MRPTypeCode}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.MRPTypeCode && <div className="text-danger">{errors.MRPTypeCode}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div>
                                        <label className="pb-2 pt-2">MRP Type Description<span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            name="MRPTypeDescription"
                                            value={mrpTypeData.MRPTypeDescription}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.MRPTypeDescription && <div className="text-danger">{errors.MRPTypeDescription}</div>}
                                </Col>
                            </Row>
                            {props.mrpTypeID && <Row>
                                <Col md={12}>
                                    <div>
                                        <label className="pb-2 pt-2">Status</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={enablingOptions}
                                            placeholder="Select"
                                            value={enablingOptions.find(option => option.value === mrpTypeData.StatusID) || null}
                                            onChange={handleStatusChange}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}
                                        />
                                    </div>
                                </Col>
                            </Row>}
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddMrpTypeData} />
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddMrpType;
